var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { Emit, Prop } from "vue-property-decorator";
import { templateVarType } from "~/config/enum.config";
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import LetterTempOne from "~/components/templete-manage/letter-template/letter-temp-one.vue";
import LetterTempTwo from "~/components/templete-manage/letter-template/letter-temp-two.vue";
import LetterTempThree from "~/components/templete-manage/letter-template/letter-temp-three.vue";
import DataBox from "~/components/common/data-box.vue";
import { TemplateService } from "~/services/manage-service/template.service";
import LetterPreview from "~/components/assistant-manage/letter-print/letter-preview.vue";
import { CaseInfoService } from "~/services/business-service/case-info.service";
import { CommonService } from "~/utils/common.service";
var letterAccModule = namespace("letter-acc");
var LetterBatchPrint = /** @class */ (function (_super) {
    __extends(LetterBatchPrint, _super);
    function LetterBatchPrint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.printDataArr = [];
        _this.currentTemplate = "";
        _this.content = [];
        _this.form = {
            resource: ""
        };
        _this.templateDataSet = [];
        _this.dialog = {
            preview: false
        };
        _this.caseMessage = [];
        return _this;
    }
    LetterBatchPrint.prototype.close = function () {
        this.printDataArr = [];
        this.currentTemplate = '';
    };
    LetterBatchPrint.prototype.refreshData = function () { };
    LetterBatchPrint.prototype.prepareData = function () {
        var _this = this;
        this.printDataArr = this.printDatas;
        this.templateService.getTemplateByType("LETTER").subscribe(function (data) {
            _this.templateDataSet = data;
        });
    };
    LetterBatchPrint.prototype.previewPrint = function () {
        if (!this.templateContent) {
            this.$message("请选择打印模板!");
            return;
        }
        this.dialog.preview = true;
    };
    Object.defineProperty(LetterBatchPrint.prototype, "templateContent", {
        get: function () {
            var _this = this;
            var result = "";
            var item = this.templateDataSet.find(function (x) { return x.id === _this.currentTemplate; });
            if (item)
                result = item.content;
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LetterBatchPrint.prototype, "previewData", {
        get: function () {
            var _this = this;
            var item = this.templateDataSet.find(function (x) { return x.id === _this.currentTemplate; });
            if (!item)
                return;
            var content = item.content;
            if (!this.printDataArr)
                return;
            templateVarType.forEach(function (x) {
                if (content.indexOf(x.value) < 0)
                    return;
                content = content.replace(x.value, "[" + x.name + "]");
            });
            return content;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 移除不打印的客户
     */
    LetterBatchPrint.prototype.removePrintClick = function (scope) {
        var arr = [];
        this.printDataArr.map(function (v, i) {
            if (i !== scope.$index) {
                arr.push(v);
            }
        });
        this.printDataArr = arr;
        // 移出数据之后需要更新store的状态
        this.updatePrintInfo(arr);
    };
    LetterBatchPrint.prototype.getPrintMessage = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.caseInfoService.getPrintMessage({ "caseIds": _this.printDataArr.map(function (x) { return x.caseId; }) }).subscribe(resolve, reject);
        });
    };
    /**
     * 一键打印
     */
    LetterBatchPrint.prototype.printAllClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var caseMessageList, printData, nWindow;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.templateContent) {
                            this.$message("请选择打印模板!");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getPrintMessage().then(function (data) { return data; }).catch(function () { return null; })];
                    case 1:
                        caseMessageList = _a.sent();
                        if (!caseMessageList) {
                            this.$message.error('获取打印内容错误');
                            return [2 /*return*/];
                        }
                        printData = this.createDom(caseMessageList);
                        nWindow = window.open(".");
                        nWindow.document.write(printData);
                        nWindow.addEventListener("afterprint", this.afterPrint);
                        nWindow.print();
                        nWindow.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterBatchPrint.prototype.afterPrint = function () {
        var _this = this;
        this.caseApplyManageService.changePrintStatus(this.printDataArr.map(function (x) { return x.processApplicationId; })).subscribe(function () {
            _this.refreshData();
        });
        this.close();
    };
    /**
     * 浏览器类型判断
     */
    LetterBatchPrint.prototype.getBrowserHeight = function () {
        var height = "1015px";
        switch (CommonService.getBrowserType()) {
            case "chrome":
            case "opera":
                height = "1025px";
                break;
            case "firefox":
                height = "1050px";
                break;
        }
        return height;
    };
    LetterBatchPrint.prototype.createDom = function (caseMessageList) {
        var _this = this;
        var domStr = caseMessageList.map(function (row) {
            return [
                "<div style=\"width:210mm;page-break-after:always\">",
                templateVarType
                    .map(function (v) { return v.value; })
                    .reduce(function (old, prop) {
                    return old.replace(new RegExp("\\" + prop, "g"), row[prop.substr(1)] || "____________________");
                }, _this.templateContent),
                "</div>"
            ].join("");
        })
            .join("");
        return ["<div>", domStr, "</div>"].join("");
    };
    __decorate([
        Dependencies(TemplateService)
    ], LetterBatchPrint.prototype, "templateService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], LetterBatchPrint.prototype, "caseInfoService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], LetterBatchPrint.prototype, "caseApplyManageService", void 0);
    __decorate([
        letterAccModule.Mutation
    ], LetterBatchPrint.prototype, "updatePrintInfo", void 0);
    __decorate([
        Prop()
    ], LetterBatchPrint.prototype, "printDatas", void 0);
    __decorate([
        Emit("close")
    ], LetterBatchPrint.prototype, "close", null);
    __decorate([
        Emit('refreshData')
    ], LetterBatchPrint.prototype, "refreshData", null);
    LetterBatchPrint = __decorate([
        Component({
            components: {
                LetterTempOne: LetterTempOne,
                LetterTempTwo: LetterTempTwo,
                LetterTempThree: LetterTempThree,
                DataBox: DataBox,
                LetterPreview: LetterPreview
            }
        })
    ], LetterBatchPrint);
    return LetterBatchPrint;
}(Vue));
export default LetterBatchPrint;
